module.exports = __webpack_public_path__ + "img/nft.792f1b90.png";